import styled from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 6px;
  overflow-y: scroll;
`;
